import { render, staticRenderFns } from "./Tipos_actividad.vue?vue&type=template&id=46f1afae"
import script from "./Tipos_actividad.vue?vue&type=script&lang=js"
export * from "./Tipos_actividad.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports